import mitt, { Emitter } from 'mitt'
const emitter: Emitter = mitt()

export default emitter
